// import { pathObj } from "@/services/apiPath";
import { pathObj } from "../../services/apiPath";
import {
  apiDelete,
  apiGet,
  apiPost,
  apiPut,
} from "../../services/httpServices";

const getEventsApi = async (data, notification, callback) => {
  callback?.(true, true, {});
  try {
    const response = await apiGet(pathObj.EVENT_LIST, data);

    if (response?.data?.success) {
      setTimeout(() => {
        callback?.(false, false, response?.data?.results);
      }, 2000);
    } else {
      callback?.(false, true, {});
      notification.error(response?.data?.message);
    }
  } catch (error) {
    callback?.(false, true, {});
    notification.error(
      error.message || "An error occurred while get the profile"
    );
    console.error(error);
  }
};

const addAndUpdateEvent = async (
  formData,
  userData,
  notification,
  callback
) => {
  callback?.(true, true); // Start loading state
  try {
    let response;
    if (userData?.modeType === "add") {
      response = await apiPost(
        pathObj.EVENT_ADD,
        formData,
        "multipart/form-data"
      );
    } else {
      response = await apiPut(
        `${pathObj.EVENT_EDIT}/${userData?.id}`,
        formData,
        "multipart/form-data"
      );
    }

    const { success, message } = response?.data || {};

    if (success) {
      notification.success(message);
      callback?.(false, false); // Stop loading state
    } else {
      callback?.(false, true); // Error state
      notification.error(message || "Update Profile failed");
    }
  } catch (error) {
    callback?.(false, true); // Error state
    const errorMessage =
      error.message || "An error occurred while updating the profile.";
    notification.error(errorMessage);
    console.error(error);
  }
};

const deleteEventApi = async (userData, notification, callback) => {
  callback?.(true, true);
  try {
    const response = await apiDelete(`${pathObj.DELETE_EVENT}/${userData?.id}`);

    const { success, message } = response?.data || {};

    if (success) {
      notification.success(message);
      callback?.(false, false);
    } else {
      callback?.(false, true);
      notification.error(message || "Delete user failed");
    }
  } catch (error) {
    callback?.(false, true); // Error state
    const errorMessage =
      error.message || "An error occurred while updating the profile.";
    notification.error(errorMessage);
    console.error(error);
  }
};

const changeStatusApi = async (data, notification, callback) => {
  callback?.(true, true); // Start loading state
  try {
    let response = await apiPut(
      `${pathObj.CHANGE_EVENT_STATUS}/${data?.id}`,
      data
    );

    const { success, message } = response?.data || {};

    if (success) {
      notification.success(message);
      callback?.(false, false); // Stop loading state
    } else {
      callback?.(false, true); // Error state
      notification.error(message || "Update Profile failed");
    }
  } catch (error) {
    callback?.(false, true); // Error state
    const errorMessage =
      error.message || "An error occurred while updating the profile.";
    notification.error(errorMessage);
    console.error(error);
  }
};

const getUserEventsApi = async (data, notification, callback) => {
  callback?.(true, true, {});
  try {
    const response = await apiGet(pathObj.EVENT_USER_LIST, data);

    if (response?.data?.success) {
      setTimeout(() => {
        callback?.(false, false, response?.data?.results);
      }, 2000);
    } else {
      callback?.(false, true, {});
      notification.error(response?.data?.message);
    }
  } catch (error) {
    callback?.(false, true, {});
    notification.error(
      error.message || "An error occurred while get the profile"
    );
    console.error(error);
  }
};

const getAllEventsApi = async (data, notification, callback) => {
  callback?.(true, true, {});
  try {
    const response = await apiGet(pathObj.ALL_EVENT_USER_LIST, data);

    if (response?.data?.success) {
      setTimeout(() => {
        callback?.(false, false, response?.data?.results);
      }, 2000);
    } else {
      callback?.(false, true, {});
      notification.error(response?.data?.message);
    }
  } catch (error) {
    callback?.(false, true, {});
    notification.error(
      error.message || "An error occurred while get the profile"
    );
    console.error(error);
  }
};

const getUserEventByIdAPI = async (data, notification, callback) => {
  callback?.(true, true, {});
  const id = data.id;
  delete data.id
  try {
    const response = await apiGet(pathObj.EVENT_USER_LIST + "/" + id, data);

    if (response?.data?.success) {
      setTimeout(() => {
        callback?.(false, false, response?.data?.results);
      }, 2000);
    } else {
      callback?.(false, true, {});
      notification.error(response?.data?.message);
    }
  } catch (error) {
    callback?.(false, true, {});
    notification.error(
      error.message || "An error occurred while get the profile"
    );
    console.error(error);
  }
};

export { getEventsApi, addAndUpdateEvent, changeStatusApi, deleteEventApi, getUserEventsApi, getUserEventByIdAPI, getAllEventsApi };
